import { Component, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { AppService } from 'shared-components';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  private titleService = inject(Title);
  private appService = inject(AppService);

  constructor() {
    this.titleService.setTitle(this.appService.appTitle);
  }
}
